<template>
  <d-badge
    :theme="statusClass"
    :outline="outline">
    {{ statusName }}
  </d-badge>
</template>

<script>
import ListUtils from '@/utils/ListUtils';

const mailingStatuses = {
  'pl': {
    'DRAFT': 'Szkic',
    'SENT': 'Wysłane',
    'TO_SEND': 'Do wysłania'
  },
  'en': {
    'DRAFT': 'Draft',
    'SENT': 'Sent',
    'TO_SEND': 'To send'
  }
};

const mailingStatusClasses = {
  'DRAFT': 'dark outline',
  'TO_SEND': 'warning',
  'SENT': 'success'
};

export default {
  name: 'mailing-status-badge',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    statusName () {
      return ListUtils.getKeyLabel(mailingStatuses[this.$i18n.locale], this.status) || this.status;
    },
    statusClass () {
      const classStr = ListUtils.getKeyLabel(mailingStatusClasses, this.status) || 'secondary';
      return classStr.replace(' outline', '');
    },
    outline () {
      const classStr = ListUtils.getKeyLabel(mailingStatusClasses, this.status) || '';
      return classStr.indexOf(' outline') > -1;
    }
  }
}
</script>
